export var Labels = {
    useHomeAsBillingAddress: '請求書先住所は送付先住所と同じ',
    addressLine1: '住所 1 行目',
    addressLine2: '住所 2 行目',
    city: '市区郡',
    state: '都道府県',
    zipCode: '郵便番号'
};
export var FieldErrors = {
    invalidAddressLine1: '有効な住所を入力してください',
    invalidCity: '有効な市区郡を入力してください',
    invalidState: '有効な都道府県を選択してください',
    invalidZipCode: '有効な郵便番号を入力してください'
};
export var States = [
    { name: '北海道', value: 'Hokkaido' },
    { name: '青森県', value: 'Aomori' },
    { name: '岩手県', value: 'Iwate' },
    { name: '宮城県', value: 'Miyagi' },
    { name: '秋田県', value: 'Akita' },
    { name: '山形県', value: 'Yamagata' },
    { name: '福島県', value: 'Fukushima' },
    { name: '茨城県', value: 'Ibaraki' },
    { name: '栃木県', value: 'Tochigi' },
    { name: '群馬県', value: 'Gunma' },
    { name: '埼玉県', value: 'Saitama' },
    { name: '千葉県', value: 'Chiba' },
    { name: '東京都', value: 'Tokyo' },
    { name: '神奈川県', value: 'Kanagawa' },
    { name: '新潟県', value: 'Niigata' },
    { name: '富山県', value: 'Toyama' },
    { name: '石川県', value: 'Ishikawa' },
    { name: '福井県', value: 'Fukui' },
    { name: '山梨県', value: 'Yamanashi' },
    { name: '長野県', value: 'Nagano' },
    { name: '岐阜県', value: 'Gifu' },
    { name: '静岡県', value: 'Shizuoka' },
    { name: '愛知県', value: 'Aichi' },
    { name: '三重県', value: 'Mie' },
    { name: '滋賀県', value: 'Shiga' },
    { name: '京都府', value: 'Kyoto' },
    { name: '大阪府', value: 'Osaka' },
    { name: '兵庫県', value: 'Hyogo' },
    { name: '奈良県', value: 'Nara' },
    { name: '和歌山県', value: 'Wakayama' },
    { name: '鳥取県', value: 'Tottori' },
    { name: '島根県', value: 'Shimane' },
    { name: '岡山県', value: 'Okayama' },
    { name: '広島県', value: 'Hiroshima' },
    { name: '山口県', value: 'Yamaguchi' },
    { name: '徳島県', value: 'Tokushima' },
    { name: '香川県', value: 'Kagawa' },
    { name: '愛媛県', value: 'Ehime' },
    { name: '高知県', value: 'Kochi' },
    { name: '福岡県', value: 'Fukuoka' },
    { name: '佐賀県', value: 'Saga' },
    { name: '長崎県', value: 'Nagasaki' },
    { name: '熊本県', value: 'Kumamoto' },
    { name: '大分県', value: 'Oita' },
    { name: '宮崎県', value: 'Miyazaki' },
    { name: '鹿児島県', value: 'Kagoshima' },
    { name: '沖縄県', value: 'Okinawa' }
];
